/* Keep the editor's product options tied to this product's native Shopify picker. */
(function () {
  'use strict';
  if (window.GIOModalVariantPicker) return;
  var states = [], serial = 0;
  function groups(picker) { return picker ? Array.prototype.slice.call(picker.querySelectorAll('fieldset, .product-form__input--dropdown')) : []; }
  function selected(group) {
    var input = group.querySelector('input[type="radio"]:checked, select');
    return input && (input.tagName === 'SELECT' ? input.selectedOptions[0] : input);
  }
  function optionId(input) { return String(input && input.getAttribute('data-option-value-id') || ''); }
  function decorate(container) {
    Array.prototype.forEach.call(container.querySelectorAll('input[type="radio"]'), function (input) {
      var label = Array.prototype.find.call(container.querySelectorAll('label[for]'), function (item) { return item.getAttribute('for') === input.id; });
      if (label && label.querySelector('img')) label.style.outline = input.checked ? '3px solid ' + (window.image_border_color || '#165d4a') : 'none';
    });
  }
  function sync(owner, container) {
    if (!owner || !container) return false;
    var nativeGroups = groups(owner.querySelector('variant-selects'));
    var modalGroups = groups(container);
    if (nativeGroups.length !== modalGroups.length) return false;
    var choices = nativeGroups.map(function (group) { return optionId(selected(group)); });
    // Validate the whole mapping before changing even one visible selection.
    if (choices.some(function (id, index) {
      return !id || !Array.prototype.some.call(modalGroups[index].querySelectorAll('input[data-option-value-id], option[data-option-value-id]'), function (input) { return optionId(input) === id; });
    })) return false;
    modalGroups.forEach(function (group, index) {
      Array.prototype.forEach.call(group.querySelectorAll('input[type="radio"]'), function (input) {
        var checked = optionId(input) === choices[index];
        if (input.checked !== checked) input.checked = checked;
        if (input.hasAttribute('checked') !== checked) input.toggleAttribute('checked', checked);
      });
      Array.prototype.forEach.call(group.querySelectorAll('option[data-option-value-id]'), function (option) {
        var checked = optionId(option) === choices[index];
        if (option.selected !== checked) option.selected = checked;
        if (option.hasAttribute('selected') !== checked) option.toggleAttribute('selected', checked);
      });
    });
    decorate(container);
    return true;
  }
  function relay(state, input) {
    if (!input || !input.matches('input[type="radio"], select')) return;
    var owner = state.owner, picker = owner.querySelector('variant-selects');
    var id = optionId(input.tagName === 'SELECT' ? input.selectedOptions[0] : input);
    var native = picker && Array.prototype.find.call(picker.querySelectorAll('input[data-option-value-id], option[data-option-value-id]'), function (item) { return optionId(item) === id; });
    if (!native) {
      sync(owner, state.container);
      state.error.textContent = 'These options changed. Close and reopen the editor to load the current choices.';
      state.error.hidden = false;
      return;
    }
    state.error.hidden = true;
    if (native.tagName === 'OPTION') {
      var select = native.closest('select');
      if (!native.selected) { select.value = native.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
    } else if (!native.checked) {
      // Preserve the native label's legacy geometry behavior, but never search
      // other products or the hidden, previous Shopify transition buffer.
      var label = Array.prototype.find.call(picker.querySelectorAll('label[for]'), function (item) { return item.getAttribute('for') === native.id; });
      if (label) label.click();
      else native.click();
    }
    decorate(state.container);
  }
  function mount(owner, container) {
    if (!owner || !container) throw new Error('The product options could not load. Refresh this page and try again.');
    var native = owner.querySelector('variant-selects');
    if (!native) { container.replaceChildren(); return true; }
    var source = owner.querySelector('.variant-content variant-selects-layer');
    if (!source) throw new Error('The product options could not load. Refresh this page and try again.');
    var clone = source.cloneNode(true), prefix = 'gio-modal-options-' + (++serial) + '-', ids = Object.create(null);
    // A copied label must never activate the hidden template's radio. Different
    // radio groups also prevent the template from unchecking the visible choice.
    Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (node, index) {
      var old = node.id, next = prefix + index;
      if (!ids[old] || node.matches('input,select,textarea')) ids[old] = next;
      node.id = next;
    });
    Array.prototype.forEach.call(clone.querySelectorAll('*'), function (node) {
      node.removeAttribute('onclick');
      ['for', 'aria-labelledby', 'aria-describedby'].forEach(function (attribute) {
        if (node.hasAttribute(attribute)) node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(function (value) { return ids[value] || value; }).join(' '));
      });
    });
    groups(clone).forEach(function (group, index) {
      Array.prototype.forEach.call(group.querySelectorAll('input,select'), function (input) {
        input.name = prefix + 'group-' + index;
        // Product choices are forwarded to the real form, never submitted from
        // the editor's personalization form or grouped with hidden inputs.
        input.setAttribute('form', prefix + 'detached');
      });
    });
    var holder = document.createElement('div'); holder.appendChild(clone);
    if (!sync(owner, holder)) throw new Error('The selected product options could not be prepared. Choose your options again and reopen the editor.');
    var state = states.find(function (item) { return item.container === container; });
    if (!state) {
      state = { owner: owner, container: container, error: null }; states.push(state);
      container.addEventListener('change', function (event) { relay(state, event.target); });
      container.addEventListener('click', function (event) {
        if (event.target.closest('label,input,select')) return;
        var swatch = event.target.closest('.swatch-element');
        var label = swatch && swatch.querySelector('label');
        if (label) label.click();
      });
    }
    state.owner = owner;
    container.replaceChildren(clone);
    state.error = document.createElement('p'); state.error.className = 'gio-editor-v2-message'; state.error.setAttribute('role', 'alert'); state.error.hidden = true;
    container.appendChild(state.error);
    return true;
  }
  document.addEventListener('gio:variant-request-state', function (event) {
    if (!event.detail || event.detail.state !== 'ready') return;
    states = states.filter(function (state) { return state.owner.isConnected && state.container.isConnected; });
    states.forEach(function (state) {
      if (state.owner !== event.target) return;
      if (sync(state.owner, state.container)) state.error.hidden = true;
      else {
        state.error.textContent = 'These options changed. Close and reopen the editor to load the current choices.';
        state.error.hidden = false;
      }
    });
  });
  window.GIOModalVariantPicker = { mount: mount, sync: sync };
}());
